module.exports = __webpack_public_path__ + "img/Debbie_King@2x.291df360.png";